module.exports = __webpack_public_path__ + "img/thumbnail_BactrianCamel_j_normal.40f71bd7.png";